module.exports = __webpack_public_path__ + "lato-hairline-italic-b4da0df63131b83ddeec1febb5b15374.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-hairline-italic/lato-hairline-italic.woff
// module id = 1037
// module chunks = 0